import {getUserEmail, openLogoutPage} from "../../Utils/authentication";
import React, {useEffect} from "react";
import {GetProfileImages} from "../../Utils/ProfilImage/ProfileImageApi";
import MailAvatar from "../CustomOdx/MailAvatar";
import {Link} from "react-router-dom";
import {odxIconSets} from "../constants";
import {VERSION} from "../../version";

const OdxHeader = () => {
    useEffect(() => {
        GetProfileImages([getUserEmail()])
    }, []);

    return (
        <div className={`odx-header `}>
            <Link to={`/`} className={`odx-header ![padding-inline-start:unset]`}>
                <odx-logo
                    id="devSecOps-logo"
                    size="sm"
                    aria-label="Dräger logo"
                    aria-roledescription="logo"
                    className="notranslate"
                />
                <div className={"odx-header__title"}>DevSecOps Hub</div>
            </Link>
            <div className={"odx-header__content"}/>
            <div style={{color: 'grey', fontSize: '0.8em', marginRight: '20px'}}>{VERSION}</div>
            <div className={"mr-2"}>
                <odx-icon-button
                    id={"HeaderNavBar_LogoutButton"}
                    variant="ghost"
                    icon={`${odxIconSets.core}::logout`}
                    size="lg"
                    onClick={() => openLogoutPage()}
                />
            </div>
            <MailAvatar size={"small"} variant={"circle"} mail={getUserEmail()} className={"odx-header__avatar"} disableTooltip={true}/>
        </div>
    )
}

export default OdxHeader;
